import { render } from "./FlashMessageView.vue?vue&type=template&id=6f19ba04"
import script from "./FlashMessageView.vue?vue&type=script&lang=js"
export * from "./FlashMessageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__